export default "__VITE_ASSET__ad809400__"